import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
export const guestRsvp = async (action: string, data: Record<string, unknown>) =>
  (await httpsCallable<Record<string, unknown>, any>(functions, 'guestRsvp')({ action, ...data }))
    .data;
